import Vue from 'vue';
import * as TypesMessage from '../types/types_message.js';
export default {
    state: {
        allMessageList: [],
        messageToken: ''
    },
    getters: {
    },
    mutations: {
        [TypesMessage.SET_MESSAGE_LIST](state, payload) {
            state.allMessageList = payload || [];
        },

        [TypesMessage.SET_MESSAGE_TOKEN](state, payload) {
            state.messageToken = payload || '';
            window.sessionStorage.setItem('message_token', payload);
        },

        [TypesMessage.ADD_MESSAGE](state, payload) {
            state.allMessageList.push(payload);
        }
    },
    actions: {
        [TypesMessage.GET_MESSAGE_TOKEN](ctx) {
            return Vue.http.post('/v1/users/message-token')
                .then(resp => {
                    return Vue.checkResp(resp);
                })
                .then(resp => {
                    return Vue.checkResp(resp);
                })
                .then(data => {
                    ctx.commit(TypesMessage.SET_MESSAGE_TOKEN, data.token);
                    return data;
                }).catch(err => { Vue.handleError(err); });
        },
        [TypesMessage.GET_MESSAGE_LIST](ctx, token) {
            return Vue.axios({
                    baseURL: `${feConfig.api.message}`,
                    headers: {'token': token},
                    withCredentials: true
                }).get('/message/inbox').then(resp => {
                    return Vue.checkResp(resp);
                })
                .then(data => {
                    let list = data.list.sort((a, b) => b.pushTime - a.pushTime);
                    ctx.commit(TypesMessage.SET_MESSAGE_LIST, list);
                    return list;
                }).catch(err => {
                        Vue.handleError(err);
                        return err;
                    });
        }
    }
};



// WEBPACK FOOTER //
// ./src/views/index/store/modules/modules_message.js